

















import { ChannelSettings, Poll, PollState } from 'shared/js/store/poll';
import { Component, Vue } from 'vue-property-decorator';
import { mapState } from 'vuex';

import VoteForm from './VoteForm.vue';

@Component({
  components: { VoteForm },
  computed: mapState('polls', ['settings'])
})
export default class PollForm extends Vue {
  public settings!: ChannelSettings;
  public sdk: any;
  public viewerIsLoggedIn: boolean = false;

  public PollState: any = PollState;

  public get accentColor(): string {
    return this.settings.accentColor;
  }

  public get textColor(): string {
    return this.settings.textColor;
  }

  public get poll(): Poll | null {
    return this.settings.poll;
  }

  public get pollIsReady(): boolean {
    if (!this.poll) {
      return false;
    }

    return (
      this.poll.state >= PollState.VotingOpen &&
      this.poll.state < PollState.Over
    );
  }

  public created() {
    this.sdk = new this.$muxy.SDK();
    this.sdk.loaded().then(() => {
      this.viewerIsLoggedIn = !this.sdk.user.anonymous();
    });
  }
}
